import styled from 'styled-components'


export const Title = styled.div`
width: 55vw;
height: 15vh;
display: flex;
align-items: center;
justify-content: flex-end;
padding: 30px;
font-size: 5vw;
font-family: Michroma;
letter-spacing: 20px;
font-weight: bold;
margin-left: ${({left}) => left ? 'inherit' : 'auto'};

background-color: ${({bg_color}) => bg_color};
font-family: ${({font}) => (font==='') ? 'inherit' : font};
font-size: ${({font_size}) => font_size};

@media screen and (max-width: 1000px) {
    font-size: 40px;
    letter-spacing: 5px;
}

@media screen and (max-width: 480px) {
    width: 100%;
}

`

export const TitleWrapper = styled.div`
height: 20vh;
width: 100%;
margin-bottom: 10vh;
`